import styled,{css}  from 'styled-components';
import media from 'src/styles/Media.styled';

export const PriceOverrideTitle = styled.p`
    margin: 8px 0;
    font-family:  'AvenirNextWorld Bold';
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #130E4A;
    opacity: 1;
`;

export const OrderDetailFooterContainer = styled.div`
    width: 100%;
    display: flex;
    margin: 8px 0;
    align-items: center;
    justify-content: flex-start;
`;

export const InvoiceCreatedDetail = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0 5px 0 0')};
    font-family: 'AvenirNextWorld Regular';
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;

    ${({ isCreatedDate }) =>
        isCreatedDate &&
        css`
            &:before,
            &:after {
                content: ' | ';
            }
        `}

    ${({ isCreatedDateBy }) =>
        isCreatedDateBy &&
        css`
            &:after {
                content: ' |';
                opacity: 20% ;
            }
        `}
`;

export const WrapperContainer = styled.div`
    display: flex;
    width: ${({ width }) => width};
    max-width: ${({ maxWidth }) => maxWidth};
    ${media.smalDevice`
    width: auto;
        max-width:unset;
        `}
    ${media.mobileDevice`
         width: auto;
         max-width:unset;
    `}
`;